<template>
  <div>
    <collapsibleItem>
      <div slot="heading">刻度</div>
      <div slot="body">
        <slider-and-input
          inputWidth="small"
          inputHeight="small"
          :value.sync="splitNumber"
          title="分段等份"
          titlePosition="singleLine"
          :sliderMax="100"
          suffix="份"
        />
        <slider-and-input
          class="mt16"
          inputWidth="small"
          inputHeight="small"
          :value.sync="splitWidth"
          title="粗细"
          titlePosition="singleLine"
          :sliderMax="20"
          suffix="px"
        />
        <slider-and-input
          inputWidth="small"
          inputHeight="small"
          :value.sync="splitLength"
          title="长度"
          titlePosition="singleLine"
          :sliderMax="50"
          suffix="px"
        />
        <!--刻度颜色-->
        <div class="mt16">
          <cx-check-box class="mb8" :value.sync="showSplitProgress">刻度颜色跟随进度</cx-check-box>
          <div class="mb8">
            <span class="fs14">默认颜色</span>
            <color-picker class="mt8" :color.sync="splitColor2" />
          </div>
          <div v-if="showSplitProgress">
            <span class="fs14">进度颜色</span>
            <color-picker class="mt8" :color.sync="splitColor1" />
          </div>
        </div>
        <!--小刻度-->
        <div class="mt16">
          <cx-check-box class="mb8" :value.sync="showMinSplit">显示小分割线</cx-check-box>
          <div v-if="showMinSplit">
            <slider-and-input
              inputWidth="small"
              inputHeight="small"
              :value.sync="minSplitNumber"
              title="分段等份"
              titlePosition="singleLine"
              :sliderMax="100"
              suffix="段"
            />
            <slider-and-input
              class="mt16"
              inputWidth="small"
              inputHeight="small"
              :value.sync="minSplitWidth"
              title="粗细"
              titlePosition="singleLine"
              :sliderMax="20"
              suffix="px"
            />
            <slider-and-input
              inputWidth="small"
              inputHeight="small"
              :value.sync="minSplitLength"
              title="长度"
              titlePosition="singleLine"
              :sliderMax="50"
              suffix="px"
            />
          </div>
        </div>
        <!--刻度文字-->
        <div class="mt16">
          <cx-check-box class="mb8" :value.sync="showAxisLabel">显示刻度文字</cx-check-box>
          <div class="mt16" v-if="showAxisLabel">
            <text-setting-update
              :fontColor.sync="axisLabelFontColor"
              :fontFamily.sync="axisLabelFontFamily"
              :fontSize.sync="axisLabelFontSize"
              :fontWeight.sync="axisLabelFontWeight"
              colorMode="chart"
            />
          </div>
          <slider-and-input
            v-if="showAxisLabel"
            inputWidth="small"
            inputHeight="small"
            :value.sync="axisLabelDistance"
            title="与大分割线间距"
            titlePosition="singleLine"
            :sliderMax="100"
            suffix="px"
          />
        </div>
      </div>
    </collapsibleItem>
    <collapsibleItem>
      <div slot="heading">外环</div>
      <div slot="body">
        <chart-color-setting class="mt8" title="颜色设置" lineDirection="y" :color.sync="outerCircleColor" />
        <slider-and-input
          class="mt16"
          inputWidth="small"
          inputHeight="small"
          :value.sync="outerCircleWidth"
          title="外环粗细"
          titlePosition="singleLine"
          :sliderMax="50"
          suffix="px"
        />
      </div>
    </collapsibleItem>
    <collapsibleItem>
      <div slot="heading">外环背景</div>
      <div slot="body">
        <div>
          <span class="fs14">背景颜色</span>
          <color-picker class="mt8" :color.sync="outerCircleBgColor" />
        </div>
        <slider-and-input
          class="mt16"
          inputWidth="small"
          inputHeight="small"
          :value.sync="outerCircleBgWidth"
          title="外环背景粗细"
          titlePosition="singleLine"
          :sliderMax="50"
          suffix="px"
        />
      </div>
    </collapsibleItem>
    <collapsibleItem>
      <div slot="heading">内环饼图</div>
      <div slot="body">
        <div>
          <span class="fs14">饼图颜色</span>
          <color-picker class="mt8" :color.sync="pieColor" />
        </div>
        <!-- 文本设置 -->
        <div class="mt16">
          <div>
            <cx-check-box :value.sync="showTitle">显示文本标题</cx-check-box>
            <div class="mt16" v-if="showTitle">
              <text-setting-update
                class="mb16"
                :fontColor.sync="titleFontColor"
                :fontFamily.sync="titleFontFamily"
                :fontSize.sync="titleFontSize"
                :fontWeight.sync="titleFontWeight"
                colorMode="chart"
              />
            </div>
          </div>
          <div class="mt16">
            <cx-check-box :value.sync="showDetail">显示数值</cx-check-box>
            <div class="mt16" v-if="showDetail">
              <text-setting-update
                :fontColor.sync="detailFontColor"
                :fontFamily.sync="detailFontFamily"
                :fontSize.sync="detailFontSize"
                :fontWeight.sync="detailFontWeight"
                colorMode="chart"
              />
            </div>
          </div>
          <div class="mt16" v-if="showDetail">
            <cx-check-box :value.sync="showLabelUnit">显示单位</cx-check-box>
            <div class="mt16" v-if="showLabelUnit">
              <span class="font14 mr10 half-label">显示文本</span>
              <el-input
                class="width-half-bigWidth el-input el-input--suffix"
                placeholder="请输入"
                v-model="showLabelUnitValue"
              >
              </el-input>
            </div>
            <!-- 字体和颜色 -->
            <!--字重和字号 -->
            <div
              class="mt16"
              v-if="showLabelUnit && (checkType(labelUnitValueFontWeight) || checkType(labelUnitValueFontColor))"
            >
              <text-setting-update
                class="mb16"
                :fontColor.sync="labelUnitValueFontColor"
                :fontFamily.sync="labelUnitValueFontFamily"
                :fontSize.sync="labelUnitValueFontSize"
                :fontWeight.sync="labelUnitValueFontWeight"
                colorMode="chart"
              />
            </div>
          </div>
        </div>
      </div>
    </collapsibleItem>
  </div>
</template>

<script>
import publicData from "../publicData"
export default {
  mixins: [publicData],
  props: {
    seriesData: {
      type: Array
    },
    ids: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      liquidFillColorList: [],
      predefineColors: [
        "#0047FF",
        "#00E4E4",
        "#FFA63F",
        "#D627B0",
        "#C035E3",
        "#802CF5",
        "#8BFF4A",
        "#FFA429",
        "#FF5C5A",
        "#FF58C7",
        "#53FFAC",
        "#FFF91F",
        "#41FFD1",
        "#6D5CFF",
        "#0089FF",
        "#FF6969",
        "#83FF7D",
        "#4EDBFF",
        "#E3FF59",
        "#B700FF"
      ],
      collapse: {} // 用来存放当前数据组和图例设置里面的展开收起状态
    }
  },
  created() {
    this.init()
  },
  watch: {
    ids: {
      deep: true,
      handler(val, oloVal) {
        this.init()
      }
    }
  },
  computed: {
    // bgColor: {
    //   get() {
    //     return this.checkAndSetPrimaryVal(this.seriesSettingItem, "backgroundStyle.color", true)
    //   },
    //   set(newVal) {
    //     this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".backgroundStyle.color", false)
    //   }
    // },
    // radius1: {
    //   get() {
    //     return parseInt(this.checkAndSetPrimaryVal(this.seriesSettingItem, "radius.0", "radius1", "30%"))
    //   },
    //   set(newVal) {
    //     if (newVal !== newVal) {
    //       // 某种情况下会操作出NaN的情况
    //       return
    //     }
    //     this.$changeOptionsEV(newVal + "%", "chartOption.series." + this.index + ".radius.0", false)
    //   }
    // },
    // radius2: {
    //   get() {
    //     return parseInt(this.checkAndSetPrimaryVal(this.seriesSettingItem, "radius.1", "radius2", "55%"))
    //   },
    //   set(newVal) {
    //     if (newVal !== newVal) {
    //       // 某种情况下会操作出NaN的情况
    //       return
    //     }
    //     this.$changeOptionsEV(newVal + "%", "chartOption.series." + this.index + ".radius.1", false)
    //   }
    // },
    showLabelUnitValue: {
      get() {
        if (typeof this.seriesData[1].detail.formatter === "string") {
          this.checkFormatterValue()
          let formatter = this.seriesData[1].detail.formatter
          const start = formatter.indexOf("valueUnit|") + 10
          let str = formatter.substring(start, formatter.length)
          const end = str.indexOf("}")
          return str.substr(0, end)
        } else {
          return ""
        }
      },
      set(newVal) {
        this.$changeOptionsEV(`{value}{valueUnit|${newVal}}`, "chartOption.series.1.detail.formatter", false)
      }
    },
    showLabelUnit: {
      get() {
        if (this.seriesData[1].detail.formatter) {
          this.checkFormatterValue()
          let formatter = this.seriesData[1].detail.formatter
          const start = formatter.indexOf("valueUnit|") + 10
          let str = formatter.substring(start, formatter.length)
          const end = str.indexOf("}")
          return str.substr(0, end).length > 0 ? true : false
        } else {
          return false
        }
      },
      set(newVal) {
        if (!newVal) {
          this.$changeOptionsEV(`{value}{valueUnit|}`, "chartOption.series.1.detail.formatter", false)
        } else {
          this.$changeOptionsEV(`{value}{valueUnit|单位}`, "chartOption.series.1.detail.formatter", false)
        }
      }
    },
    labelUnitValueFontFamily: {
      get() {
        return this.seriesData[1].detail.rich.valueUnit.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.1.detail.rich.valueUnit.fontFamily", false)
      }
    },
    labelUnitValueFontSize: {
      get() {
        return this.seriesData[1].detail.rich.valueUnit.fontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.1.detail.rich.valueUnit.fontSize", false)
      }
    },
    labelUnitValueFontWeight: {
      get() {
        return this.seriesData[1].detail.rich.valueUnit.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.1.detail.rich.valueUnit.fontWeight", false)
      }
    },
    labelUnitValueFontColor: {
      get() {
        return this.seriesData[1].detail.rich.valueUnit.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.1.detail.rich.valueUnit.color", false)
      }
    },
    splitNumber: {
      get() {
        return this.seriesData[0].splitNumber
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.splitNumber", false)
      }
    },
    // 每一段之间的刻度数
    showMinSplit: {
      get() {
        return this.seriesData[0].axisTick.show
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.axisTick.show", false)
      }
    },
    minSplitNumber: {
      get() {
        return this.seriesData[0].axisTick.splitNumber
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.axisTick.splitNumber", false)
      }
    },
    splitColor: {
      get() {
        return this.seriesData[0].axisLine.lineStyle.color[0][1]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.axisLine.lineStyle.color.0.1", false)
      }
    },
    splitWidth: {
      get() {
        return this.seriesData[0].splitLine.lineStyle.width
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.splitLine.lineStyle.width", false)
      }
    },
    splitLength: {
      get() {
        return this.seriesData[0].splitLine.length
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.splitLine.length", false)
      }
    },
    minSplitWidth: {
      get() {
        return this.seriesData[0].axisTick.lineStyle.width
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.axisTick.lineStyle.width", false)
      }
    },
    minSplitLength: {
      get() {
        return this.seriesData[0].axisTick.length
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.axisTick.length", false)
      }
    },
    // 进度
    progress() {
      return 0.16
    },
    // 刻度颜色
    showSplitProgress: {
      get() {
        return this.seriesData[0].axisLine.lineStyle.color.length > 1 ? true : false
      },
      set(newVal) {
        let color = this.seriesData[0].axisLine.lineStyle.color
        if (newVal) {
          let color1 = [this.progress, color[0][1]]
          color.unshift(color1)
        } else {
          color.splice(0, 1)
        }
      }
    },
    splitColor1: {
      get() {
        return this.seriesData[0].axisLine.lineStyle.color[0][1]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.axisLine.lineStyle.color.0.1", false)
      }
    },
    splitColor2: {
      get() {
        let color = this.seriesData[0].axisLine.lineStyle.color
        return color[color.length - 1][1]
      },
      set(newVal) {
        let index = this.seriesData[0].axisLine.lineStyle.color.length - 1
        this.$changeOptionsEV(newVal, "chartOption.series.0.axisLine.lineStyle.color." + index + ".1", false)
      }
    },
    // 刻度文字
    showAxisLabel: {
      get() {
        return this.seriesData[0].axisLabel.show
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.axisLabel.show", false)
      }
    },
    axisLabelDistance: {
      get() {
        return this.seriesData[0].axisLabel.distance
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.axisLabel.distance", false)
      }
    },
    axisLabelFontFamily: {
      get() {
        return this.hasProperty(this.seriesData[0], "axisLabel.fontFamily") || "sans-serif"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.axisLabel.fontFamily", false)
      }
    },
    axisLabelFontColor: {
      get() {
        return this.hasProperty(this.seriesData[0], "axisLabel.color") || "#464646"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.axisLabel.color", false)
      }
    },
    axisLabelFontWeight: {
      get() {
        return this.hasProperty(this.seriesData[0], "axisLabel.fontWeight") || "400"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.axisLabel.fontWeight", false)
      }
    },
    axisLabelFontSize: {
      get() {
        return this.hasProperty(this.seriesData[0], "axisLabel.fontSize") || 12
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.axisLabel.fontSize", false)
      }
    },
    // 外环设置
    outerCircleColor: {
      get() {
        return this.seriesData[1].axisLine.lineStyle.color[0][1]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.1.axisLine.lineStyle.color.0.1", false)
      }
    },
    outerCircleWidth: {
      get() {
        return this.seriesData[1].axisLine.lineStyle.width
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.1.axisLine.lineStyle.width", false)
      }
    },
    // 外环背景
    outerCircleBgWidth: {
      get() {
        return this.seriesData[2].axisLine.lineStyle.width
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.2.axisLine.lineStyle.width", false)
      }
    },
    outerCircleBgColor: {
      get() {
        return this.seriesData[2].axisLine.lineStyle.color[0][1]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.2.axisLine.lineStyle.color.0.1", false)
      }
    },
    // 显示标签文字
    showDetail: {
      get() {
        return this.seriesData[1].detail.show
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.1.detail.show", false)
      }
    },
    labelFormatter: {
      get() {
        return this.hasProperty(this.seriesData[1], "detail.formatter")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.1.detail.formatter", false)
      }
    },
    detailFontFamily: {
      get() {
        return this.seriesData[1].detail.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.1.detail.fontFamily", false)
      }
    },
    detailFontColor: {
      get() {
        return this.seriesData[1].detail.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.1.detail.color", false)
      }
    },
    detailFontWeight: {
      get() {
        return this.seriesData[1].detail.fontWeight || "400"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.1.detail.fontWeight", false)
      }
    },
    detailFontSize: {
      get() {
        return this.seriesData[1].detail.fontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.1.detail.fontSize", false)
      }
    },
    pieColor: {
      get() {
        return this.seriesData[3].itemStyle.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.3.itemStyle.color", false)
      }
    },
    // 显示标签文字
    showTitle: {
      get() {
        return this.seriesData[1].title.show
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.1.title.show", false)
      }
    },
    titleDetail: {
      get() {
        return this.seriesData[1].title.show
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.1.title.show", false)
      }
    },
    titleFontFamily: {
      get() {
        return this.seriesData[1].title.fontFamily || "sans-serif"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.1.title.fontFamily", false)
      }
    },
    titleFontColor: {
      get() {
        return this.seriesData[1].title.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.1.title.color", false)
      }
    },
    titleFontWeight: {
      get() {
        return this.seriesData[1].title.fontWeight || "400"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.1.title.fontWeight", false)
      }
    },
    titleFontSize: {
      get() {
        return this.seriesData[1].title.fontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.1.title.fontSize", false)
      }
    }
  },
  methods: {
    init() {},
    checkFormatterValue() {
      if (!this.seriesData[1].detail.formatter) {
        this.$changeOptionsEV("{value}{valueUnit| }", "chartOption.series.1.detail.formatter", false)
        this.$changeOptionsEV(
          {
            valueUnit: {
              fontFamily: "sans-serif",
              color: "rgba(255,255,255,1)",
              fontWeight: "400",
              fontSize: 14
            }
          },
          "chartOption.series.1.detail.rich",
          false
        )
      }
    },
    collapsibleItemClickHandle($event, index) {
      this.collapse[$event.type].isActive = $event.isActiveCopy
      const _index = this.collapseDataActiveNames.findIndex(it => it === index)
      _index === -1 ? this.collapseDataActiveNames.push(index + "") : ""
    }
  }
}
</script>

<style scoped>
.width_100 {
  width: 100%;
}
.custom-color {
  display: inline-block;
  width: calc(100% - 72px);
  vertical-align: middle;
}
.pie-options-setting-dialog .tabs-color {
  width: 86px;
  height: 24px;
}
.pie-options-setting-dialog .tabs-color .tabs-color-item {
  padding: 0 8px;
  background: #35383f;
  border-radius: 3px;
  position: static;
  width: 42px;
  height: 22px;
  font-size: 13px;
  line-height: 18px;
  color: #717989;
  cursor: pointer;
}
.pie-options-setting-dialog .tabs-color .tabs-color-item.active {
  background: var(--themeColor);
  color: #ffffff;
}
.percent65_ {
  width: calc(100% - 65px);
}
</style>
